const Project = {
  baseUrl: process.env.REACT_APP_BASEURL,
  publicKey: process.env.REACT_APP_PUBLICKEY,
  stripeApiKey: process.env.REACT_APP_STRIPE_API_KEY,
  googleApiKey: "AIzaSyD4NDWyZ5OoCxzS2YCB81Fsk456t7vC4vk",
  reCAPTCHASitekey: "6Ld7ug4TAAAAANwINpM8tISk0L23n43iQAfEv1t4",
  alarmWebhookUrl: "https://api.safe.land/rest/alarm",
  smhiHelpUrl: "https://www.safeland.se/se/integration-med-smarta-hem/",
  smhiAjaxHelpUrl: "https://www.safeland.se/se/ajax-smart-home-integration/",
  alarmSMSHelpUrl: "https://www.safeland.se/se/alarmsms/",
  phones: {
    support: "+46 766 86 12 19",
    contact: "010 222 99 00",
  },
  emails: {
    support: "support@safeland.se",
    contact: "kontakt@safeland.se",
  },
  urls: {
    connect: "https://www.safeland.se/butik/connect/",
    alarmCentral: "https://www.safeland.se/larmcentral-med-vaktare/",
    alarmServices: "https://www.safeland.se/butik/larmtjanster/",
    connectWebhook:
      "https://www.safeland.se/se/blogg/sa-ansluter-du-ditt-larmsystem-med-webhook/",
    connectAlarmSMS:
      "https://www.safeland.se/se/funktioner-och-uppdateringar/sms-larm-anslut-dig-till-safelands-larmtjanster/",
    homeAlarm: "https://www.safeland.se/butik/hemlarm/",
    ajax: "https://www.safe.land/butik/ajax/",
  },
};

const Constants = Object.freeze({
  Project,
  isDev: Project.baseUrl.includes("test"),
});

export default Constants;
